export const ACTION_TYPES = {
    TOGGLE_MODAL: '[modal] action toggle modal',
    CLOSE_MODAL: '[modal] action close modal',
};
